module.exports = __webpack_public_path__ + "static/media/close-btn.b602f8d7.svg";